// tourSteps.js
import { Textarea } from "@heroui/react"
import { motion } from 'framer-motion';

export const tourSteps = [
    {
        // dashboard purpose
        chapterBeginning: true,
        id: "first-text",
        target: "navbar",
        path: "/reading/:id",
        fallbackPath: "/materials",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>ようこそ、aomeへ。</p>
            <p>ここから、あなたと英語の旅が始まります。</p>

            <p>一つひとつの言葉の意味から、文全体の意味を組み立ててください。</p>
            <p>言葉同士が、どう繋がり、どう変化しながら働いているかも、見てください。</p>

            <p>知らない言葉には「＋」を。</p>
            <p>はじめのうちは、よく知っている言葉にも「よく知っている」をつけて、aomeにあなたのことを伝えてください。</p>
            <p>それからは、出会うものの多くが、自然と新しい言葉になっていきます。伝えるほど、届く文章が、あなたに近づいていきます。</p>

            <p>わからないことは、失敗ではありません。それは、学びが始まっている証拠です。</p>
            <p>今、無理に理解しようとしなくても大丈夫です。何度も出会ううちに、自分の中に染み込んでいきます。</p>

            <p>まずは、最初の文章のすべての言葉に、印をつけてみてください。</p>
        </div>,
        placement: "center",
        padding: 0,
        spotlightMode: "none",
        hideArrow: true,
        // left: -10,
        className: "w-[350px]",
        currentStep: 1,
        totalSteps: 4,
        buttonContent: "はじめる"
    },
    {
        id: "first-new-word",
        target: "first-new-word",
        showReminder: true,
        path: "/reading/:id",
        fallbackPath: "/materials",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>言葉をタップして、意味を確認してください。</p>
            <p>一度「新しい」か「よく知っている」を選んだ後も、その言葉はいつでもまたタップできます。緑でなくなっても。</p>
        </div>,
        placement: "bottom-left",
        padding: { x: 3, y: 10 },
        className: "w-[250px]",
        currentStep: 2,
        totalSteps: 4
    },

    {
        id: "ask-aome-gen-reading",
        target: "ask-aome",
        path: "/reading/:id",
        fallbackPath: "/materials",
        showReminder: true,
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>文章や映像をまるごと理解しようとする中で、うまく繋がらない部分や、なんとなく気になる働き。それが、問いです。</p>

            <p>どんな形でも、構いません。例えば——</p>

            <p>「ここ、何を言っているのか、全然わからない。」</p>
            <p>「これは、どうしてそこと繋がっているんだろう？」</p>
            <p>「この言葉、いつもこう変わるのかな？ それとも、ここだけ？」</p>
            <p>「意味はわかる。それでも、なぜこう言うんだろう？」</p>

            <p>そう感じたら、アオメへ。</p>

            <p>一度の答えで、すべてがわかる必要はありません。むしろ、一度で終わらない問いほど、遠くまで届きます。問うこと自体が積み重なり、感覚になっていきます。 </p>
        </div>,
        placement: "top-right",
        left: 10,
        className: "w-[320px]",
        currentStep: 3,
        buttonContent: "わかった",
        totalSteps: 4,
        dismissable: true,
        delay: 2000,
        disableScroll: true
    },
    {
        // dashboard purpose
        id: "first-text-completed",
        target: "navbar",
        path: ["/reading/:id"],
        showReminder: true,
        fallbackPath: "/materials",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>言葉に、初めて向き合いました。今、あなたが実際にやったことです。</p>
            <p>これから何度も繰り返す、その最初の一回。</p>
            <p>さあ、言葉へ。あなたが出会った言葉が、そこに並んでいます。</p>
        </div>,
        placement: "center",
        padding: 0,
        spotlightMode: "none",
        hideArrow: true,
        // left: -10,
        className: "w-[350px]",
        currentStep: 4,
        totalSteps: 4,
        delay: 1000,
        condition: (state) => state.wordCounts?.young + state.wordCounts?.buried + state.wordCounts?.new + state.wordCounts?.mature >= 14
    },
    {
        id: "my-deck",
        target: "my-deck",
        path: "/vocabulary",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>ここは、あなたがaomeに伝えてきた言葉が、集まる場所です。</p>
            <p>「新しい」も、「よく知っている」も——その一つひとつが、あなたについて、aomeに教えてくれます。</p>
            <p>その中でも、新しく出会った言葉には、aomeが寄り添い続けます。</p>
            <p>忘れかけた頃に、もう一度、それを差し出しながら。</p>
        </div>,
        placement: ["top-left", "left"],
        className: "w-[300px]",
        disableScroll: true,
        // top: [-10, 10],
        currentStep: 1,
        totalSteps: 4
    },
    {
        id: "starter-deck",
        target: "starter-deck",
        path: "/vocabulary",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>ここには、よく使われる言葉が集まっています。多く知っていても、知らなくても、大丈夫です。</p>
            <p>知っている言葉が多いなら、設定から「よく知っている」をまとめて選べます。一つずつでも、まとめてでも。</p>
            <p>急がなくて大丈夫です。伝えたぶんだけ、aomeがあなたの語彙を掴みやすくなります。</p>
        </div>,
        placement: ["bottom-left", "right"],
        className: "w-[300px]",
        disableScroll: true,
        top: [-10, 10],
        currentStep: 2,
        totalSteps: 4
    },
    {
        id: "dashboard-tab",
        target: "dashboard-tab",
        excludePath: "/dashboard",
        description: <div className="flex flex-col gap-0 text-base-text font-light">
            <p>今日は、ここまで。</p>
            <p>ホームで、続きを。</p>
        </div>,
        placement: ["top", "right"],
        className: "w-[250px]",
        left: [-20, undefined],
        right: [undefined, 17],
        top: [undefined, 20],
        currentStep: 3,
        totalSteps: 4
    },
    {
        id: "final-message",
        target: "navbar",
        path: "/dashboard",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>ここが、あなたのホームです。やることに迷ったら、いつでもここへ。その日のタスクが、ここに並びます。</p>
            <p>今日の分は、もう終わりました。もし、もう少し続けたければ、そのまま進んで大丈夫です。aomeの中には、まだ見ていないものがたくさんあります。</p>
            <p>言葉を集めるほど、アオメも、新しい姿を見せてくれます。その成長も、ここに映し出されます。</p>
            <p>明日、今日出会った言葉が、もう一度戻ってきます。</p>
        </div>,
        placement: ["top", "right"],
        padding: 0,
        spotlightMode: "none",
        hideArrow: true,
        left: -10,
        className: ["w-[350px]", "w-[450px]"],
        currentStep: 4,
        totalSteps: 4,
        buttonContent: "わかった"
    },
    {
        id: "part-one-complete",
        target: "navbar",
        path: "/dashboard",
        description: ({ value, onChange }) => (
            <div className="flex flex-col gap-2 text-base-text font-light px-2">
                <p>英語で、誰かに伝えたいことはありますか。</p>
                <p>どんなことでも。仕事のこと、好きなもの、いつか話してみたい相手のこと。</p>
                <p>日本語で、そのまま書いてください。</p>
                <Textarea
                    classNames={{
                        inputWrapper: "bg-containerBg/40 border border-containerBg/50 group-data-[focus=true]:border-containerBg group-data-[focus=true]:bg-containerBg450 shadow-none",
                        input: "font-light text-base-text/50 group-data-[has-value=true]:text-base-text "
                    }}
                    className="max-w-xs"
                    placeholder="例：週末に友達と話したこと。"
                    value={value}
                    onValueChange={onChange}   // heroui Textarea uses onValueChange, not onChange
                />
            </div>
        ),
        requiresInput: true,
        confirmationContent: <div className="w-full items-center justify-center py-5 flex flex-col gap-2 text-base-text font-light px-2">
            <motion.div
                initial={{ filter: 'blur(20px)', opacity: 0 }}
                animate={{ filter: 'blur(0px)', opacity: 1 }}
                transition={{ duration: 0.5, delay: 0 }}
            >覚えておきます。</motion.div>
        </div>,
        placement: "center",
        padding: 0,
        spotlightMode: "none",
        hideArrow: true,
        className: ["w-[350px]", "w-[450px]"],
        currentStep: 4,
        totalSteps: 4,
        hideProgress: true,
        allowSkip: true,
        buttonContent: "伝える"
    },

    {
        // chat purpose
        chapterBeginning: true,
        id: "chat-page",
        target: "navbar",
        path: "/writing-practice",
        noNavigation: true,
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>ここでは、言いたいことが言葉になります。</p>
            <p>まず、日本語で感じてください。本当に言いたいことを、完全に。</p>

            <p>それから、その言葉に届こうとしてください。</p>
            <p>知らない言葉は、調べながら使えばいい。語彙の制限はありません。</p>

            <p>言いたいことを、パズルのように組み立ててください。</p>

            <p>できれば、組み立てながら、声に出してみてください。</p>

            <p>読んだり聴いたりして、体に染み込んできた感覚を、信じてください。</p>
            <p>うまく言えないとき、その「届かなさ」の中に、本当の学びがあります。</p>

            <p>アオメは、その先を一緒に見つけようとします。</p>

            <p>時々、表現に下線を引くことがあります。</p>

            <p>それは、あなたが伸ばした手に、アオメが応えている形です。</p>
        </div>,
        placement: ["top", "right"],
        padding: 0,
        spotlightMode: "none",
        hideArrow: true,
        left: -10,
        className: "w-[350px]",
        currentStep: 1,
        totalSteps: 4
    },

    {
        id: "chat-modes",
        target: "chat-modes",
        path: "/writing-practice",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>じっくり対話と、瞬発対話、2つのモードがあります。</p>
            <p>じっくり対話が、aomeの中心です。</p>
            <p>ここでの積み重ねは、ずっと続いていきます。</p>
            <p>瞬発対話は、時間を意識した会話を試してみたいときに。</p>
            <p>気になったときに、のぞいてみてください。</p>
        </div>,
        placement: "bottom",
        className: "w-[350px]",
        bottom: 10,
        left: -50,
        padding: { x: 30, y: 10 },
        currentStep: 2,
        totalSteps: 4
    },

    {
        id: "chat-functions",
        target: "chat-functions",
        path: "/writing-practice",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>使いたい言葉やフレーズが思いつかないときは、ここで調べます。</p>
            <p>見つけた言葉は、メッセージに挿入したり、使い方を確認したりできます。</p>
        </div>,
        placement: ["top-right", "left"],
        className: "w-[250px]",
        disableScroll: true,
        delay: 4000,
        currentStep: 3,
        totalSteps: 4
    },

    {
        id: "part-three-complete",
        target: "navbar",          // no anchor, maybe a centered modal
        path: "/dashboard",
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>これで、すべてが揃いました。</p>
            <p>『言葉』『探索』『対話』。</p>
            <p>毎日のリズムが、ここに完成します。</p>
            <p>最初に伝えたこと、覚えていますか。</p>
            <p>言語に、しっかりとつかめる型なんてない。それでいい。</p>
            <p>その感覚を抱えながら、ここから先は、あなた自身の歩みです。</p>
            <p>問い、観察し、言葉に手を伸ばす—— その積み重ねの先で、あなたがどんな人になっているか。</p>
            <p>アオメは、それを楽しみにしています。</p>
        </div>,
        placement: ["top", "right"],
        padding: 0,
        spotlightMode: "none",
        hideArrow: true,
        left: -10,
        className: "w-[350px]",
        currentStep: 4,
        totalSteps: 4,
        buttonContent: "わかった"
    }
]

export const NUDGE_CONFIG = [
    {
        shownFlag: 'nudgeDayTwoShown',
        relatedHintFlags: ['flashcardFrontHintShown', 'flashcardBackHintShown'],
        navigateToPath: "/vocabulary",
        message: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>また、会いに来てくれましたね。</p>
            <p>言語が自分のものになっていくのは、こうして戻り続けることの積み重ねです。そして今日、あなたは自分でここへ戻ってきました。</p>
            <p>今日は、言葉に会いに行ってみてください。昨日出会ったものが、もう戻ってきているかもしれません。</p>
        </div>,
        alternative: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>また、会いに来てくれましたね。</p>
            <p>今日のタスクが、ここに並んでいます。</p>
        </div>,
        alternativeButtonContent: "わかった",
        className: "w-[320px]"
    },
    {
        shownFlag: 'nudgeDayThreeShown',
        relatedHintFlags: ['videoHintShown'],
        navigateToPath: "/materials",
        message: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>続けて、戻ってきてくれましたね。</p>
            <p>言葉を組み立てる感覚は、目だけでなく、耳でも働きます。</p>
            <p>今日は、その感覚を、音の中で試してみてください。</p>
            <p>英語の音に、耳を傾けてみてください。</p>
        </div>,
        alternative: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>また、会いに来てくれましたね。</p>
            <p>今日のタスクが、ここに並んでいます。</p>
        </div>,
        className: "w-[320px]",
        alternativeButtonContent: "わかった",
    },
    {
        shownFlag: 'nudgeDayFourShown',
        relatedHintFlags: [],
        target: "chat-tab",
        message: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>その進捗バー、満ちていくのに気づいていましたか。</p>
            <p>読むこと、聞くこと、思い出すこと。アオメと共に、もう三つのことを経験しました。残るは、一つだけです。</p>
            <p>言いたいことを、言葉にする番が、もうすぐやってきます。</p>
            <p>それまでは、今の三つを、大切に積み重ねてください。</p>
        </div>,
        alternative: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>その進捗バー、満ちていくのに気づいていましたか。</p>
            <p>読むこと、聞くこと、思い出すこと。アオメと共に、もう三つのことを経験しました。残るは、一つだけです。</p>
            <p>言いたいことを、言葉にする番が、もうすぐやってきます。</p>
            <p>それまでは、今の三つを、大切に積み重ねてください。</p>
        </div>,
        excludePath: "/writing-practice",
        placement: ["top-right", "right"],
        padding: [undefined, { top: 10, bottom: 15, right: 15, left: 15 }],
        className: "w-[320px]",
        left: [10, undefined],
        right: [undefined, 17],
        top: [10, 20],
        currentStep: 12,
        totalSteps: 13,
        alternativeButtonContent: "わかった",
    },
]

export const flashcardHintSteps = [
    {
        flag: 'flashcardFrontHintShown',
        target: "word-review",
        path: "/vocabulary",
        description: <div className="flex flex-col gap-0 text-base-text font-light">
            <p>英語を見て、声に出して読んでください。</p>
            <p>そして、意味を思い出してみてください。</p>
            <p>わからなくても大丈夫。</p>
            <p>まず、思い出そうとすることが大切です。</p>
            <p>準備ができたら、カードをタップすると裏返ります。</p>
        </div>,
        placement: "bottom-inside",
        className: "w-[300px]",
        disableScroll: true,
        padding: { top: 3, left: 3, right: 10, bottom: 8 },
        hideArrow: true,
        bottom: -15,
        currentStep: 1,
        totalSteps: 2
    },
    {
        flag: 'flashcardBackHintShown',
        target: "review-buttons",
        path: "/vocabulary",
        description: <div className="flex flex-col gap-0 text-base-text font-light">
            <p>正直に選んでください。</p>
            <p>1 — まったく思い出せなかった</p>
            <p>2 — 訳を見て思い出せた</p>
            <p>3 — 自力で思い出せたが、少し迷った</p>
            <p>4 — すぐに思い出せた</p>
            <p>正直であるほど、aomeは忘れる直前のタイミングを正確に捉え、その言葉を届けます。</p>
            <p>その一回一回が、言葉を自分のものにしていきます。</p>
        </div>,
        placement: "top-left",
        className: "w-[300px]",
        disableScroll: true,
        padding: [-10, { top: -3, right: -25, left: -25, bottom: -30 }],
        left: 10,
        currentStep: 2,
        totalSteps: 2,
        buttonContent: "はじめる"
    },
]

export const videoHintSteps = [
    {
        flag: 'videoHintShown',
        target: 'navbar',
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>英語の音とリズムを、体で感じる場所です。</p>
            <p>まず、字幕を読みながら観てください。</p>
            <p>『読む』でしているように、音を感じながら、意味を自分で組み立ててみてください。</p>
            <p>次に、戻ってきてください。組み立てられなかった部分へ。</p>
            <p>字幕をタップして、言葉を観察する。</p>
            <p>気になる場面があれば、その行を選んで、そのままアオメに問うこともできます。文脈は、自動で伝わります。</p>
            <p>そしてもう一度、観てください。</p>
            <p>今度は、組み立てた意味と、音が、ひとつに繋がって聞こえてきます。</p>
            <p>その繰り返しの中で、英語は体に染み込んでいきます。</p>
        </div>,
        placement: ["top", "right"],
        padding: 0,
        spotlightMode: "none",
        hideArrow: true,
        left: -10,
        className: ["w-[350px]", "w-[450px]"],
        buttonContent: "わかった",
        hideProgress: true
    },
]

export const grammarHintSteps = [
    {
        flag: 'grammarHintShown',
        target: 'navbar',
        description: <div className="flex flex-col gap-2 text-base-text font-light">
            <p>英語は、バラバラなルールの集まりではありません。すべてが、緩やかに繋がった、一つの全体です。</p>
            <p>一つに触れると、その繋がりは、どこか別の場所にも伸びていく。だからこそ、これは、覚えるものではなく、感じるものです。</p>
            <p>ここにあるものを、すべてに目を通す必要はありません。気になるものに出会ったら、その繋がりをたどるように、英語の動き方を感じてみてください。</p>
            <p>問いが生まれたら、アオメへ。いつでも、戻ってこられます。</p>
        </div>,
        placement: ["top", "right"],
        padding: 0,
        spotlightMode: "none",
        hideArrow: true,
        left: -10,
        className: ["w-[350px]", "w-[450px]"],

        buttonContent: "わかった",
        hideProgress: true
    },
]

export const textReminder = {
    id: "first-text",
    target: "navbar",
    path: "/reading/:id",
    description: <div className="flex flex-col gap-2 text-base-text font-light">
        <p>ようこそ、aomeへ。</p>
        <p>ここから、あなたと英語の旅が始まります。</p>

        <p>一つひとつの言葉の意味から、文全体の意味を組み立ててください。</p>
        <p>言葉同士が、どう繋がり、どう変化しながら働いているかも、見てください。</p>

        <p>知らない言葉には「＋」を。</p>
        <p>はじめのうちは、よく知っている言葉にも「よく知っている」をつけて、aomeにあなたのことを伝えてください。</p>
        <p>それからは、出会うものの多くが、自然と新しい言葉になっていきます。伝えるほど、届く文章が、あなたに近づいていきます。</p>

        <p>わからないことは、失敗ではありません。それは、学びが始まっている証拠です。</p>
        <p>今、無理に理解しようとしなくても大丈夫です。何度も出会ううちに、自分の中に染み込んでいきます。</p>

        <p>まずは、最初の文章のすべての言葉に、印をつけてみてください。</p>
    </div>,
    placement: "center",
    padding: 0,
    spotlightMode: "none",
    hideArrow: true,
    className: "w-[350px]",
    currentStep: 1,
    totalSteps: 4,
    buttonContent: "はじめる"
}